import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { compareValuesOperator } from './compareValuesOperator.js';

/**
 * Component rendering conditionally it's content
 * More documentation in the [wiki](https://gaminginnovationgroup.atlassian.net/l/c/2QhiF9ch)
 */
var ConditionalComponent = /** @class */ (function (_super) {
    __extends(ConditionalComponent, _super);
    function ConditionalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConditionalComponent.prototype, "matches", {
        /**
         * check condition matches
         */
        get: function () {
            return compareValuesOperator(this.value1, this.condition, this.value2);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], ConditionalComponent.prototype, "value1", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], ConditionalComponent.prototype, "value2", void 0);
    __decorate([
        Prop({ type: String, default: 'does exist' }),
        __metadata("design:type", String)
    ], ConditionalComponent.prototype, "condition", void 0);
    ConditionalComponent = __decorate([
        Component({ name: 'ui-conditional' })
    ], ConditionalComponent);
    return ConditionalComponent;
}(Mixins(MagicConfigMixin)));

export default ConditionalComponent;
